import gql from "graphql-tag";

export const USER_FRAGMENT = gql`
  fragment user on UserType {
    id
    username
    email
    firstName
    lastName
    isActive
  }
`;

export const FETCH_ALL_USRS = gql`
  query FETCH_ALL_USERS {
    allUsers {
      ...user
    }
  }
  ${USER_FRAGMENT}
`;

export const SAVE_USER = gql`
  mutation SAVE_USER($userInput: UserInput!) {
    saveUser(userInput: $userInput) {
      user {
        ...user
      }
    }
  }
  ${USER_FRAGMENT}
`;
